// extracted by mini-css-extract-plugin
module.exports = {"tabs-list":"Tabs-module__tabs-list___7EJgN","active":"Tabs-module__active___eRUue"};